import React, { useContext, useState } from 'react';

interface AppealProviderProps {
  children: React.ReactNode;
}
interface IAppealProvider {
  refresh: number[];
  refreshAnswer: number[];
  solveHandler: any;
  removeRefreshed: any;
  setupAnswers: any;
  removeRefreshedAnswer: any;
}
const def: IAppealProvider = {
  refresh: [],
  refreshAnswer: [],
  solveHandler: () => {
    return;
  },
  removeRefreshed: () => {
    return;
  },
  setupAnswers: () => {
    return;
  },
  removeRefreshedAnswer: () => {
    return;
  },
};
const AppealContext = React.createContext(def);

export const AppealProvider = (props: AppealProviderProps): JSX.Element => {
  const [refresh, setRefresh] = useState<number[]>([]);
  const [refreshAnswer, setRefreshAnswer] = useState<number[]>([]);
  const solveHandler = (id: number): void => {
    setRefresh((prev) => [...prev, id]);
  };
  const setupAnswers = (id: number): void => {
    setRefreshAnswer((prev) => [...prev, id]);
  };
  const removeRefreshed = (id: number): void => {
    const newRefresh = refresh.filter((el) => el !== id);
    setRefresh(newRefresh);
  };
  const removeRefreshedAnswer = (id: number): void => {
    const newRefreshAnswers = refreshAnswer.filter((el) => el !== id);
    setRefreshAnswer(newRefreshAnswers);
  };
  return (
    <AppealContext.Provider
      value={{
        refresh,
        refreshAnswer,
        solveHandler,
        removeRefreshed,
        setupAnswers,
        removeRefreshedAnswer,
      }}
    >
      {props.children}
    </AppealContext.Provider>
  );
};

export const useAppeal = () => {
  return useContext(AppealContext);
};
